import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, OnInit, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MbscDraggableModule, MbscDropcontainerModule } from '@mobiscroll/angular';
import { RosterAbsenceService } from '../../services/roster-absence.service';
import { Absence } from '../../types/absence';

@Component({
  selector: 'soft-absence',
  imports: [CommonModule, MbscDraggableModule, MbscDropcontainerModule],
  templateUrl: './absence.component.html',
  styleUrl: './absence.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [],
})
export class AbsenceComponent implements OnInit {
  private readonly absenceService = inject(RosterAbsenceService);

  // private readonly params = signal({});
  readonly size = input<DOMRect | null>();

  readonly absence: Signal<Absence[]> = computed(() => this.absenceService.all());

  ngOnInit(): void {
    // this.absenceService.registerParams(this.params);
  }
}
